/* eslint-disable camelcase */
import React, { memo } from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import sx from './styles'

const HightlightText = ({ title }) => {
  return (
    <Box>
      <Container
        maxWidth="lg"
        sx={sx.root}
      >
        <Grid
          container
          justifyContent="center"
          sx={sx.container}
        >
          <Grid
            textAlign="center"
            sx={sx.item}
            size={12}
          >

            <Typography
              variant="h3"
              textAlign="center"
              sx={sx.text}
            >
              {title}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default memo(HightlightText)
